import React, { useState, useEffect,useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getDrug } from "../Actions/drugAction";
import Header from "./Header";
import Sidebar from "./Sidebar";
import CandidateTab from "./CandidateTab";
import NotificationPanels from "./NotificationPanels";
import "../assets/css/candidate-tab-form.css";
import "../assets/css/inner-tabs.css";
import Footer from './Footer.js';
import StepCount from "./Common/StepCount";
import {
  getEducation,
  updateCampusHireEducation,
} from "../Actions/educationActions";

import MainForm from "./DrugForm/MainForm";
import QuestionForm from "./EducationForm/QuestionForm";

import { useParams } from "react-router-dom";
import ClientSideBar from "./Partials/ClientSideBar";
import ClientHeader from "./Partials/ClientHeader";
import ProgressHeading from "./Common/ProgressHeading.jsx";

const DrugCheck = () => {
  let { activeTab } = useParams();
  const form = useRef();

  const [data, setData] = useState([]);
  const [role,setRole]=useState();

  const storeDrugData = useSelector((state) => state.drug);

  const dispatch = useDispatch();

  const { drugData, loadingData, error } = storeDrugData;

  useEffect(() => {
    if (typeof drugData.data !== "undefined" && drugData.data !== null) {
      setData(drugData.data.data);
    }
  }, [drugData, storeDrugData]);

  console.log(data);

  const autoLoginStore = useSelector((state) => state.autoLogin);
  const { autoLoginData, loadingLogin } = autoLoginStore;

  useEffect(() => {
    if (
      typeof autoLoginData?.status !== "undefined" &&
      autoLoginData?.status !== null
    ) {
      
     setRole(autoLoginData.data.user_role);
    }
  }, [autoLoginData, autoLoginStore]);

  useEffect(() => {
    const fetchData = async () => {
      dispatch(getDrug());
    };

    fetchData();
  }, []);

  const reRenderAgain = (value) => {
    dispatch(getDrug());
  };

  return (
    <>
      <NotificationPanels />
      {role=="EP"? <ClientHeader />:<Header/>}
      {role=="EP"? <ClientSideBar /> :<Sidebar/>}
      {/* <Header />
      <Sidebar /> */}

      <section
        className="main-section candidate-tab-form"
        style={{ paddingTop: "60px" }}
      >
        <div className="container-fluid">
          <div className="row">
            <div className="col-auto w-100-mbl bg-gray-mbl">
              <ProgressHeading/>
              <CandidateTab activeTab={"Drug Check"} />
            </div>
            <div className="col bg-gray-mbl">
              <br/>
              <StepCount activeTab={"Drug Check"}/>
                <h2 className="fnt-smi-bld">Drug Check</h2>
                <p className="text-muted">
                Please provide the address  to schedule your drug sample collection
                </p>
                <MainForm
                  drug={data}
                  reRenderAgain={reRenderAgain}
                  active={activeTab}
                />
            
              {/*Form*/}
              {/* <form ref={form} className="p-3 form2 form-section" style={{ minHeight: '700px' }}> */}

              {/* </form> */}
              {/*Form*/}
              <div className="mt-4">
                <div className="row mb-3">
                  <div className="col-md-12 d-flex align-items-center btn-and-info-responsive">
                    {/* <button className="btn btn-primary btn-lg mr-3">Submit for Preview</button>
                    <span className="text-muted">Please complete the all mandatory fields before final submission</span> */}
                  </div>
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default DrugCheck;
